import client from './internal/httpClient';

// 部署体检
export const deployCheck = () => client.get('/admin/deploy/check');

// 一键装库：{ host, port, database, username, password }
export const deployInstall = (payload) => client.post('/admin/deploy/install', payload);
